<form (ngSubmit)="save()" [formGroup]="workflowForm">

  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{workflow?.id ? 'Update' : 'New'}} Workflow
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <mat-form-field>
      <input placeholder="Name" formControlName="name" matInput/>
    </mat-form-field>
    <mat-form-field>
        <textarea placeholder="Description"
                  rows="6" formControlName="description" matInput></textarea>
    </mat-form-field>
    <mat-slide-toggle
      align="right"
      color="primary"
      formControlName="is_enabled"
    >
      Enabled
    </mat-slide-toggle>
  </div>

  <div class="modal-footer">
    <button class="btn btn-primary"
            [disabled]="workflowForm.invalid">Save
    </button>
    <button type="button" class="btn btn-danger" (click)="closeModal()">Cancel</button>
  </div>

</form>
